import React, {Component} from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {Link} from 'react-router-dom';
import {PropTypes} from 'prop-types';
// import { VARS } from '../../../config';

import IndicatorItem from './item';
import PopupJCR from './popup/2_PopupJCR';
import PopupKCI from './popup/2_PopupKCI';
import PopupScopus from './popup/2_PopupScopus';

import * as func from "../../../../../utils/functions";

import * as FActions from "../../../../../store/modules/footer";
import {objectToQueryString, pushUrl} from "../../../../../utils/functions";
import {BASE_PATH} from "../../../../../wpconfig";

const activePopup = {
	0: <PopupJCR/>,
	1: <PopupKCI/>,
	2: <PopupScopus/>
}

class Indicator extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showPopup1: false,
			showPopup2: false,
			showPopup3: false,
			param : {
				type : ['all'],
				order_by : 'type',
				order : 'asc'
			},
			indicatorList: [],
			openIndicatorID: 0,
			pkKey: "indicator_id"
		};

		this.onUpdate = this.onUpdate.bind(this)
		this.onRemove = this.onRemove.bind(this)
		this.showMessage = this.showMessage.bind(this)
		this.onType = this.onType.bind(this)
	}

	componentDidMount() {
		this.getData()
	}

	getData = () => {
		func.getData("admin/journal/" + func.getParams("record_id") + '/indicator', this.state.param).then((response) => {
			if(response.records) {
				this.setState({
					indicatorList: response.records
				})
			}
		})
	}

	openPopup = (type, indicatorId) => {

		this.setState({
			openIndicatorID: indicatorId,
		})

		switch (type) {
			case "jcr":
				this.togglePopup1()
				break;
			case "kci":
				this.togglePopup2()
				break;
			case "scopus":
				this.togglePopup3()
				break;
		}
	}

  initIndicatorId = () => {
		this.setState({
			openIndicatorID: 0
		})
  }

	togglePopup1 = () => {
		this.setState({
			showPopup1: !this.state.showPopup1,
		}, () => {
			this.getData()
      this.initIndicatorId()
    });

	}

	togglePopup2 = () => {
		this.setState({
			showPopup2: !this.state.showPopup2,
		}, () => {
			this.getData()
      this.initIndicatorId()
		});
	}

	togglePopup3 = () => {
		this.setState({
			showPopup3: !this.state.showPopup3,
		}, () => {
			this.getData()
      this.initIndicatorId()
		});
	}

	onUpdate(index, item, render) {
		const record = this.state.indicatorList;
		record[index] = item;
		// this.props.dataActions.setJournal({"record": record});
		this.setState({ indicatorList : record })
		if(render)
			this.forceUpdate();
	}

	onRemove(index) {
		const record = this.state.indicatorList;
		record.splice(index, 1);
		this.setState({ indicatorList : record })
		this.forceUpdate();
	}

	onEditIndex(id) {
		if(this.state.editIndex === id)
			return;
		if(this.state.editIndex && this.refs["ref" + this.state.editIndex])
			this.refs["ref" + this.state.editIndex].onClose();
		else if(this.refs.ref)
			this.refs.ref.onClose();
		else if(this.refs["ref" + this.state.editIndex])
			this.refs["ref" + this.state.editIndex].onClose();

		this.setState({
			'editIndex' : id
		})
	}

	showMessage(message) {
		this.props.fDataActions.setFooter({
			'isNoticePopup': true,
			'noticeMessage': message
		})
		setTimeout(() => {
			this.props.fDataActions.setFooter({
				'isNoticePopup': false,
				'noticeMessage': ''
			})
		}, 3000);
	}

	onType = (event) => {
		let param = this.state.param
		if(event.target.checked) {
			if(event.target.value === 'all') {
				param['type'] = ['all']
			} else {
				if(param['type'].includes(event.target.value)) {
				} else {
					param['type'].push(event.target.value)
				}
				if(param['type'].includes("all")) {
					const idx = param['type'].indexOf("all")
					if (idx > -1) param['type'].splice(idx, 1)
				}
				if(param['type'].length >= 3) {
					param['type'] = ['all']
				}
			}
		} else {
			if(event.target.value === 'all') {
			} else {
				const idx = param['type'].indexOf(event.target.value)
				if (idx > -1) param['type'].splice(idx, 1)
				if(param['type'].length <= 0) {
					param['type'] = ['all']
				}
			}
		}

		this.setState({param:param})
		this.forceUpdate()

		func.getData("admin/journal/" + func.getParams("record_id") + '/indicator', param).then((response) => {
			if(response.records) {
				this.setState({
					indicatorList: response.records
				})
			}
		})
	}

	order = (key) => {
		let param = this.state.param;
		if(param.order_by === key) {
			if (param.order === 'asc')
				param.order = 'desc'
			else
				param.order = 'asc'
		} else {
			param.order_by = key
			param.order = 'desc'
		}

		this.setState({param:param})

		func.getData("admin/journal/" + func.getParams("record_id") + '/indicator', param).then((response) => {
			if(response.records) {
				this.setState({
					indicatorList: response.records
				})
			}
		})
	}

	render() {
		const arr = [
			{'label' : '전체','value' : 'all'},
			{'label' : 'JCR','value' : 'jcr'},
			{'label' : 'Scopus','value' : 'scopus'},
			{'label' : 'KCI','value' : 'kci'},
		];
		const {togglePopup1, togglePopup2, togglePopup3} = this;

		return (
			<>
				<h5 className="mt-4 mb-4">Indicator 정보</h5>
				<div className="d-flex mb-3">
					<div className="flex-grow-1">
						{arr.map((item, idx) => {
							return (
								<div className="form-check form-check-inline" key={idx}>
									<input
										className="form-check-input"
										type="checkbox"
										id={"inlineCheckbox" + idx}
										onChange={this.onType}
										checked={this.state.param.type.includes(item.value)}
										value={item.value}
									/>
									<label
										className="form-check-label"
										htmlFor={"inlineCheckbox" + idx}>
										{item.label}
									</label>
								</div>
							)
						})}
					</div>
					<div className="btn-group" role="group">
						<button type="button" className="btn btn-secondary btn-sm" onClick={togglePopup1}>New JCR</button>
						<button type="button" className="btn btn-secondary btn-sm" onClick={togglePopup2}>New KCI</button>
						<button type="button" className="btn btn-secondary btn-sm" onClick={togglePopup3}>New Scopus</button>
					</div>
				</div>

				<table className="table table-striped table-thin mb-1 border-bottom journal-indicator-list">
					<thead>
					<tr>
						<th className={"pt-2 pb-2 order" + (this.state.param.order_by === 'type' ? ' active' : '')} onClick={() => this.order('type')}>
							유형
							{this.state.param.order_by ==='type' && this.state.param.order ==='asc'?<span>▲</span>:<span>▼</span>}
						</th>
						<th className={"order" + (this.state.param.order_by === 'date' ? ' active' : '')} onClick={() => this.order('date')}>
						  년도
							{this.state.param.order_by ==='date' && this.state.param.order ==='asc'?<span>▲</span>:<span>▼</span>}
						</th>
						<th>Impact</th>
						<th>EigenFactor</th>
						<th>Ranking</th>
						<th>Action</th>
					</tr>
					</thead>
					<tbody>
					{
						this.state.indicatorList &&
						this.state.indicatorList.map((record, index) => {
							return (
								<IndicatorItem
									key={record[this.state.pkKey]}
									index={record[this.state.pkKey]}
									ref={"ref" + record[this.state.pkKey]}
									arrIndex={index}
									pkKey={this.state.pkKey}
									// key={record.indicator_id}
									// arrIndex={index}
									id={record.indicator_id}
									type={record.indicator_type}
									edition={record.edition}
									ranking_type={record.ranking_type}
									year={record.indicator_year}
									impact={record.impact}
									eigenfactor={record.eigen_factor}
									ranking={record.ranking}
									openPopup={this.openPopup}
									onUpdate={this.onUpdate}
									onRemove={this.onRemove}
									onEditIndex={this.onEditIndex}
									showMessage={this.showMessage}
								/>
							)
						})
					}
					</tbody>
				</table>

				{this.state.showPopup1 ? <PopupJCR togglePopup={togglePopup1} indicator_id={this.state.openIndicatorID}/> : null}
				{this.state.showPopup2 ? <PopupKCI togglePopup={togglePopup2} indicator_id={this.state.openIndicatorID}/> : null}
				{this.state.showPopup3 ? <PopupScopus togglePopup={togglePopup3} indicator_id={this.state.openIndicatorID}/> : null}
			</>
		)
	}
}

export default connect(
	(state) => ({}),
	(dispatch) => ({
		fDataActions: bindActionCreators(FActions, dispatch)
	}),
)(Indicator)
